import React from "react";
import IIntegration from "../../../../models/IIntegration";
import ConfirmationTextDialog from "../../../modals/ConfirmationTextDialog";
import { IntegrationStatuses } from "../../IntegrationStatuses";

interface IIntegrationDiscontinueDialogProps {
  showDialog: boolean;
  setShowDialog: (val: boolean) => void;
  form: IIntegration;
  handleSubmit: (val: IIntegration) => void;
}

export const IntegrationDiscontinueDialog = (props: IIntegrationDiscontinueDialogProps): JSX.Element => {
  const { showDialog, setShowDialog, form, handleSubmit } = props;

  const handleDiscontinueConfirm = () => {
    let tempForm: IIntegration = {
      ...form,
      Status: {
        ID: IntegrationStatuses.Discontinued,
        Name: "Discontinued",
      },
    };

    setShowDialog(false);
    handleSubmit(tempForm);
  };

  const onClose = () => {
    setShowDialog(false);
  };

  return (
    <ConfirmationTextDialog
      isOpen={showDialog}
      title={`Discontinue ${form.Name} Integration`}
      confirmationText={form.Name}
      contentTexts={[
        "Discontinuing will cause your Integration to no longer be available to customers.",
        `To confirm this action, type ${form.Name} on the line below and click Discontinue.`,
      ]}
      buttonText="Discontinue"
      onConfirm={handleDiscontinueConfirm}
      onCancel={onClose}
    />
  );
};
